import { useState, useEffect, useMemo, useRef, forwardRef } from "react";
import { Form } from "react-bootstrap";
import axios from "axios";
import BASE_URL from "../../../assets/global/url";
import swal from "sweetalert";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import NoAccess from "../../../assets/img/NoAccess.png";
import useDecodeToken from "../../../hooks/customHook/useDecodeToken";
import CustomDatePicker from "../../../components/CustomDatePicker";
import { useObserver } from "../../../hooks/customHook/useObserver";
import { parseNumber } from "../../../utils/numberFormatter";
import TotalCard from "./components/TotalCard";
import ProductionConsumableCreateTable from "./components/ProductionConsumableCreateTable";
import { showDeficitAlert } from "../../../utils/showDeficitAlert";
import ProductionMaterialsCreateTable from "./components/ProductionMaterialsCreateTable";
import ProductionFinishedCreateTable from "./components/ProductionFinishedCreateTable";
import { usePostedCutoffValidation } from "../../../hooks/customHook/usePostedCutoffValidation";

function NewProductionUpdate({ authrztn }) {
  const { id } = useParams();
  const userLoggedID = useDecodeToken();
  const navigate = useNavigate();
  const shiftWarehouseRef = useRef();
  const [vendorOptions, setVendorOptions] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [dateProduce, setDateProduce] = useState(""); // End date
  const { postedCutoffValidation } = usePostedCutoffValidation();
  const { containerRef, containerItemRefs, visible } = useObserver();

  const [rawMaterials, setRawMaterials] = useState([]);
  const [validated, setValidated] = useState(false);
  const [submittingAction, setSubmittingAction] = useState(null); // "update" | "approve" | "reject" | null
  const submittingRef = useRef(false); // Sync guard against fast double clicks
  const [finishProducts, setFinishProducts] = useState([]);

  const [production, setProduction] = useState([]);
  const [productionId, setProductionId] = useState("");
  const [description, setDescription] = useState("");
  const [wareHouseID, setWareHouseID] = useState("");
  const [fetchWarehouse, setFetchWarehouse] = useState([]);
  const [shift, setShift] = useState("");
  const [machine, setMachine] = useState("");
  const [status, setStatus] = useState("");

  const [trigger, setTrigger] = useState(0);

  const [edit, setEdit] = useState(false);
  const [selectedConsumable, setSelectedConsumable] = useState("");
  const [quantity, setQuantity] = useState("");
  const [averagePrice, setAveragePrice] = useState("");
  const [total, setTotal] = useState("");
  const [consumableMaxQuantity, setConsumableMaxQuantity] = useState(0);

  //States PRoduction
  const [stockConsumableProducts, setStockConsumableProducts] = useState([]);
  const [stock_raw_products, setStock_raw_products] = useState([]); // stocks management table fetch
  const [stock_finish_products, setStock_finish_products] = useState([]); // product table fetch
  const [consumableList, setConsumableList] = useState([]);

  const [consumablesTotalWeight, setConsumablesTotalWeight] = useState(0);
  const [consumablesTotalCosting, setConsumablesTotalCosting] = useState(0);
  const [materialToDelete, setMaterialToDelete] = useState([]);
  const [consumableToDelete, setConsumableToDelete] = useState([]);
  const [materialsTotalWeight, setMaterialsTotalWeight] = useState(0);
  const [materialsTotalCosting, setMaterialsTotalCosting] = useState(0);
  const [finishedTotalWeight, setFinishedTotalWeight] = useState(0);
  const [finishedTotalCosting, setFinishedTotalCosting] = useState(0);
  const [lastFocusedIndex, setLastFocusedIndex] = useState(null); // Last focused input field for produce
  const [lastFocusedIndexUnitPrice, setLastFocusedIndexUnitPrice] =
    useState(null); // Last focused input field for Unit Price
  const [firstMount, setFirstMount] = useState(true);
  const [existingRaw, setExistingRaw] = useState([]);
  const [existingConsumables, setExistingConsumables] = useState([]); // Initial values upon editing
  const [consumables, setConsumables] = useState([
    {
      stock_id: "",
      prod_id: "",
      prod_code: "",
      prod_name: "",
      prod_uom: "",
      current_stock: "",
      prod_price: "",
      weightIn: 0,
      cost: "",
    },
  ]);

  const [raws, setRaws] = useState([
    {
      stock_id: "",
      vendor_id: "Any",
      supplier_code: "Any",
      prod_id: "",
      prod_code: "",
      prod_name: "",
      prod_uom: "",
      current_stock: "",
      prod_price: "",
      weightIn: 0,
      cost: "",
    },
  ]);

  const [finishedProductRows, setFinishedProductRows] = useState([
    {
      prod_id: "",
      prod_code: "",
      prod_name: "",
      prod_uom: "",
      produce: 0,
      current_stock: 0,
      costing: 0,
      unit_price: 0,
    },
  ]);

  const addNewItemConsumable = () => {
    setConsumables((prev) => [
      ...prev,
      {
        stock_id: "",
        prod_id: "",
        prod_code: "",
        prod_name: "",
        prod_uom: "",
        current_stock: "",
        prod_price: "",
        weightIn: 0,
        cost: "",
      },
    ]);
  };

  const addNewItemRaw = () => {
    setRaws((prev) => [
      ...prev,
      {
        stock_id: "",
        vendor_id: "Any",
        supplier_code: "Any",
        prod_id: "",
        prod_code: "",
        prod_name: "",
        prod_uom: "",
        current_stock: "",
        prod_price: "",
        weightIn: 0,
        cost: "",
        newItem: true,
      },
    ]);
  };

  const addNewItemFinishProduct = () => {
    setFinishedProductRows((prev) => [
      ...prev,
      {
        newItem: true,
        prod_id: "",
        prod_code: "",
        prod_name: "",
        prod_uom: "",
        produce: 0,
        current_stock: 0,
        costing: 0,
        unit_price: 0,
      },
    ]);
  };

  // Finished Product Unit Price
  const unitPrice =
    materialsTotalCosting && finishedTotalWeight
      ? parseFloat(
          String(materialsTotalCosting / finishedTotalWeight).replace(/,/g, ""),
        ) || 0
      : 0;

  const filteredConsumableOptions = (index) => {
    const prodId = consumables
      .filter((_, i) => i !== index)
      .map((item) => item.prod_id);

    return stockConsumableProducts.filter(
      (item) => !prodId.includes(item.product_id),
    );
  };

  // Get all products that are not selected yet
  const getAvailableProducts = (index, vendorId, isVendorAny) => {
    // All raw material ids except the one at the current index
    const prodId = raws
      .filter((_, i) => i !== index)
      .map((item) => item.prod_id);

    const availableProducts = stock_raw_products.filter((item) => {
      const notSelected = !prodId.includes(item.product_id); // Checks whether the product is not currently selected

      return isVendorAny
        ? notSelected // Include all unselected products, no vendor filter (Any)
        : notSelected && item.vendor_id === vendorId; // Include unselected products for the selected vendor
    });

    return availableProducts;
  };

  // prettier-ignore
  // For raw material average price computation
  const getAveragePrice = (existingProduct, newProduct) => {
    const existingProductTotalPrice = existingProduct.totalStock * existingProduct.averagePrice;
    const newProductTotalPrice = newProduct.totalStock * newProduct.averagePrice;
    const totalStock = existingProduct.totalStock + newProduct.totalStock;
    const averagePrice = totalStock ? (existingProductTotalPrice + newProductTotalPrice) / totalStock : 0;

    return averagePrice;
  };

  // Group products for vendor "Any" supplier code option
  const groupProducts = (availableProducts) => {
    const products = availableProducts.reduce((acc, value) => {
      const productId = value.product_id;

      if (!acc.has(productId)) {
        acc.set(productId, { ...value }); // Clone object to avoid mutating original state object
      } else {
        const product = acc.get(productId);
        const newAverage = getAveragePrice(product, value);
        product.totalStock += value.totalStock;
        product.averagePrice = newAverage;
      }

      return acc;
    }, new Map());

    return Array.from(products.values());
  };

  // prettier-ignore
  // For raw materials options
  const filteredRawProductOptions = (index, vendorId) => {
    const isVendorAny = vendorId === "Any";
    const availableProducts = getAvailableProducts(index, vendorId, isVendorAny);
    const consolidatedProducts = groupProducts(availableProducts);

    return isVendorAny ? consolidatedProducts : availableProducts;
  };

  const filteredFinishedProductOptions = (index) => {
    const prodId = finishedProductRows
      .filter((_, i) => i !== index)
      .map((item) => item.prod_id);

    return stock_finish_products.filter(
      (item) => !prodId.includes(item.product_id), // flat, no product_list wrapper
    );
  };

  const onInputFloat = (e) => {
    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
  };

  const deleteItemConsumable = (indexToDelete, data) => {
    setConsumables((prev) =>
      prev.filter((_, index) => index !== indexToDelete),
    );

    const findConsumable = existingConsumables.find(
      (item) => item.prod_id === data.prod_id,
    );

    if (!findConsumable) return;

    setConsumableToDelete((prev) => [...prev, findConsumable]);
  };

  const deleteItemRaw = (indexToDelete, data) => {
    // setTrigger(trigger + 1);
    setRaws((prevRaws) =>
      prevRaws.filter((_, index) => index !== indexToDelete),
    );

    const findRaw = existingRaw.find((item) => item.prod_id === data.prod_id);

    if (!findRaw) return;

    if (!data.newItem) {
      setMaterialToDelete((prev) => [...prev, findRaw]);
    }
  };

  const deleteFinishedProduct = (indexToDelete) => {
    setTrigger(trigger + 1);
    setFinishedProductRows((prevRows) => {
      // Don't delete if it's the only row
      if (prevRows.length === 1) {
        return prevRows;
      }
      return prevRows.filter((_, index) => index !== indexToDelete);
    });
  };

  const fetchStockConsumables = async (warehouse_id) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/production/consumables/summary`,
        {
          params: {
            selectedWarehouse: warehouse_id,
          },
        },
      );

      if (res.data) {
        setStockConsumableProducts(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchStockRaw = (warehouse_id) => {
    axios
      .get(BASE_URL + "/production/getRawProd", {
        params: {
          selectedWarehouse: warehouse_id,
          usage: "For Production Details", // To allow fetching product with 0 stock
        },
      })
      .then((res) => {
        setStock_raw_products(res.data);
        console.log(
          "*****-------------------------------------------------*res.data: ",
          res.data,
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchStockFinish = () => {
    axios
      .get(BASE_URL + "/production/getFinishedProductsProduction")
      .then((res) => setStock_finish_products(res.data))
      .catch((err) => console.log(err));
  };

  const fetchWarehouse_function = () => {
    axios
      .get(BASE_URL + "/warehouse/getWarehouse")
      .then((res) => {
        setFetchWarehouse(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // To Initialize the consumable display
  const fetchConsumables = async (warehouseId) => {
    try {
      const res = await axios.get(`${BASE_URL}/production/consumables/${id}`, {
        params: {
          warehouseId,
        },
      });

      const { productId, unitPrice, quantity, total, maxQuantity } = res.data;

      setSelectedConsumable(productId);
      setQuantity(putComma(quantity || 0));
      setAveragePrice(putComma(unitPrice || 0));
      setTotal(total ?? 0);

      setConsumableMaxQuantity(maxQuantity); // Initialize Max Quantity for selected consumable
    } catch (error) {
      console.error(error);

      if (error.response && error.response.status === 404) {
        setSelectedConsumable(null);
        setQuantity("");
        setAveragePrice("");
        setTotal("");
      }
    }
  };

  // Fetch vendor with supplier code
  const fetchVendor = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/vendors/supplier-code`);

      const any = {
        label: "Any",
        value: "Any",
      };

      const options = res.data.map((item) => ({
        label: item.supplier_code,
        value: item.vendor_id,
      }));

      setVendorOptions([any, ...options]);
    } catch (error) {
      console.error(error);
    }
  };

  // Get the raw material stock based on specified warehouse and vendor id
  const fetchRawMaterialStock = async (warehouseId, vendorId) => {
    try {
      const res = await axios.get(`${BASE_URL}/production/getRawProd`, {
        params: {
          selectedWarehouse: warehouseId,
          vendorId,
        },
      });

      return res.data;
    } catch (error) {
      console.error(error);
    }
  };

  // To get the List of Consumable for Dropdown select
  const fetchConsumableList = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/production/consumables/list`);

      setConsumableList(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  // To get the amount details of the selected consumable
  const fetchConsumableAmounts = async (consumableId) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/production/consumables/${consumableId}/summary`,
      );

      const { totalStock, averagePrice } = res.data;

      setQuantity(putComma(totalStock || 0));
      setAveragePrice(putComma(averagePrice || 0));
      setTotal(totalStock * averagePrice || 0);

      setConsumableMaxQuantity(totalStock);
    } catch (error) {
      console.error(error);
    }
  };

  const recalculateTotal = (quantity, averagePrice) => {
    setTotal(quantity * averagePrice);
  };

  // Put Comma to numbers
  const putComma = (num) => {
    let [integerPart, decimalPart] = String(num).split(".");

    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    return formattedValue;
  };

  // Handle Quantity and Unit Price change
  const handleAmountChange = (value, setter) => {
    let inputValue = String(value).replace(/[^0-9.]/g, "");

    const formattedValue = putComma(inputValue);

    const cleanedValue = formattedValue.replace(/^0+,|^0+/, ""); // Remove leading zeros and comma

    setter(cleanedValue);
  };

  const validRawMaterials = raws.filter((raw) => raw.stock_id && raw.prod_name);

  const fetchInventoryCounting = () => {
    axios
      .get(`${BASE_URL}/production/getProductionDetails/${id}`)
      .then((res) => {
        const quantity = putComma(res.data.quantity);
        const averagePrice = putComma(res.data.average_price);
        const total = putComma(res.data.total);

        setProduction(res.data);
        setProductionId(res.data.production_id);
        setDescription(res.data.desc || "");
        setStartDate(res.data.start_date);
        setDateProduce(res.data.date_produce);
        setShift(res.data.shift);
        setMachine(res.data.machine);
        setWareHouseID(res.data.warehouse_id);
        fetchConsumables(res.data.warehouse_id);
        // fetchStockFinish(res.data.warehouse_id);
        fetchStockRaw(res.data.warehouse_id);
        fetchStockConsumables(res.data.warehouse_id);
        setStatus(res.data.status);
        // fetchRawMaterials(res.data.warehouse_id);
        fetchExistingConsumable(res.data.warehouse_id);
        getRawMaterials(res.data.warehouse_id, res.data.status);
      })
      .catch((error) => {
        console.error("Error fetching production details: ", error);
      });
  };

  // Handle supplier code change
  const handleSupplierCodeChange = async (selectedOption, index, data) => {
    const { prod_id: productId, prod_name: productName } = raws[index];
    const vendorId = selectedOption.value;
    const supplierCode = selectedOption.label;

    // Get the updated stock with the current selected warehouse and vendor
    const stockRawProducts = await fetchRawMaterialStock(wareHouseID, vendorId);

    const hasProduct = stockRawProducts.some((p) => p.product_id === productId); // Check if selected vendor has the selected product

    // Validation: prevent proceeding when the selected product does not exist for the chosen supplier
    if (!hasProduct && productId) {
      swal({
        icon: "error",
        title: "No Raw Material Found",
        text: `No ${productName} found with supplier code ${supplierCode}`,
      });
      return;
    }

    const selectedProduct = filteredRawProductOptions(index, vendorId).find(
      (product) => product.product_id === productId,
    );

    // Add the current row as deleted
    if (!data.newItem) {
      setMaterialToDelete((prev) => [...prev, data]);
    }

    // Update vendor id, current stock, quantity and unit price for the selected row
    setRaws((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              vendor_id: vendorId,
              supplier_code: supplierCode,
              current_stock: selectedProduct?.totalStock || 0,
              prod_price: selectedProduct?.averagePrice || 0,
              weightIn: "",
              newItem: true,
            }
          : item,
      ),
    );
  };

  // Lock all action buttons while a request is in flight
  const startSubmitting = (action) => {
    if (submittingRef.current) return false;
    submittingRef.current = true;
    setSubmittingAction(action);
    return true;
  };

  const stopSubmitting = () => {
    submittingRef.current = false;
    setSubmittingAction(null);
  };

  const renderButtonLabel = (action, label, loadingLabel) =>
    submittingAction === action ? (
      <>
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        {loadingLabel}
      </>
    ) : (
      label
    );

  const handleUpdateProduction = async (e) => {
    try {
      e.preventDefault();
      if (submittingRef.current) return;
      const form = e.currentTarget;

      const modifiedFinishedProductRows = finishedProductRows
        .filter((item) => item.prod_id)
        .map((item) => ({
          ...item,
          produce: parseNumber(item.produce),
        }));

      const formatRaws = raws
        .filter((item) => item.prod_id && parseNumber(item.weightIn) >= 0)
        .map((item) => ({
          ...item,
          weightIn: parseNumber(item.weightIn),
        }));

      const formatConsumables = consumables
        .filter((item) => item.prod_id && parseNumber(item.weightIn) >= 0)
        .map((item) => ({
          ...item,
          weightIn: parseNumber(item.weightIn),
        }));

      const hasMaterials = formatRaws.length > 0;
      const hasFinishedProducts = modifiedFinishedProductRows.length > 0;

      if (form.checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();
        swal({
          icon: "error",
          title: "Fields are required",
          text: "Please fill in the red text fields.",
        });
      } else if (!hasMaterials && !hasFinishedProducts) {
        swal({
          icon: "error",
          title: "No Items Added",
          text: "Please add at least one Raw Material or Finished Product.",
        });
      } else {
        let confirmTitle = "Update this production?";
        let confirmText = "Please review the details before updating.";
        let isWarning = false;

        if (hasMaterials && !hasFinishedProducts) {
          confirmTitle = "No Finished Products Selected";
          confirmText =
            "You are updating a production to have ONLY Raw Materials. Proceed?";
          isWarning = true;
        } else if (!hasMaterials && hasFinishedProducts) {
          confirmTitle = "No Raw Materials Selected";
          confirmText =
            "You are updating a production to have ONLY Finished Products. Proceed?";
          isWarning = true;
        }

        swal({
          title: confirmTitle,
          text: confirmText,
          icon: "warning",
          buttons: {
            cancel: {
              text: "Cancel",
              value: null,
              visible: true,
              closeModal: true,
            },
            confirm: {
              text: "Yes, Update",
              value: true,
              visible: true,
              className: "btn-primary",
              closeModal: true,
            },
          },
          dangerMode: isWarning,
        })
          .then(async (confirmed) => {
            if (confirmed) {
              if (!startSubmitting("update")) return;

              const res = await axios.put(
                `${BASE_URL}/production/updateProductionNew`,
                {
                  raws: formatRaws,
                  finishedProductRows: modifiedFinishedProductRows,
                  productionId,
                  description,
                  startDate,
                  dateProduce,
                  wareHouseID,
                  shift,
                  machine,
                  userLoggedID,
                  id,
                  materialToDelete,
                  consumableId: selectedConsumable,
                  quantity,
                  averagePrice,
                  total,
                  totalQuantity: materialsTotalWeight,
                  totalProduce: finishedTotalWeight,
                  consumables: formatConsumables,
                },
              );

              if (res.status === 200) {
                swal({
                  title: "Success",
                  text: "Production updated successfully",
                  icon: "success",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                }).then(() => {
                  reloadData();
                  setEdit(false);
                  stopSubmitting();
                });
              } else {
                stopSubmitting();
              }
            }
          })
          .catch((error) => {
            stopSubmitting();

            if (error.response && error.response.status === 409) {
              swal({
                icon: "error",
                title: "Oppss!",
                text: error.response.data.message,
                timer: 2000,
                buttons: false,
              });
              return;
            }

            if (error.response && error.response.status === 400) {
              swal({
                icon: "error",
                title: error.response.data.title,
                text: error.response.data.message,
              });
            }
          });
      }
      setValidated(true);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchExistingConsumable = async (warehouseId) => {
    try {
      const productionId = id;
      const res = await axios.get(
        `${BASE_URL}/production/consumables/${productionId}`,
        {
          params: {
            warehouseId,
          },
        },
      );

      if (res.data.length) {
        const consumables = res.data.map((item) => {
          const weightIn = item.weight_in;
          const addWeightIn = status === "Rejected" ? 0 : weightIn || 0;

          return {
            stock_id: item.product_id,
            prod_id: item.product_id,
            prod_code: item.product_code,
            prod_name: item.product_name,
            prod_uom: item.unit_of_measure,
            current_stock: item.totalStock + addWeightIn,
            prod_price: item.production_price,
            weightIn: weightIn,
            cost: item.costing,
          };
        });

        setConsumables(consumables);
        setExistingConsumables(consumables);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchRawMaterials = async (wareHouseID) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/production/getProductionRawUsed/${id}`,
        {
          params: {
            warehouse_id: wareHouseID,
          },
        },
      );

      const productMap = new Map();

      response.data.forEach((item) => {
        const productId = item.product_id;
        const weightIn = item.weight_in || 0;
        const price = item.stock_management?.price || 0;

        if (!productMap.has(productId)) {
          productMap.set(productId, {
            stock_id: item.product_id,
            vendor_id: item.vendor_id,
            prod_id: item.product_id,
            prod_code: item.product_list?.product_code || "",
            prod_name: item.stock_management?.product_list?.product_name || "",
            prod_uom:
              item.stock_management?.product_list?.unit_of_measure || "",
            // current_stock: item.total_stock + weightIn || 0,
            current_stock:
              item.total_stock +
              (item.production.status === "Rejected" ? 0 : weightIn || 0),
            prod_price: item.production_price || 0,
            production_id: item.production_id,
            weightIn: weightIn,
            // cost: price * weightIn,
            cost: 0,
            priceSum: price,
            itemCount: 1,
          });
        } else {
          const existing = productMap.get(productId);
          existing.weightIn += weightIn;
          // existing.cost += price * weightIn;
          existing.priceSum += price;
          existing.itemCount += 1;
          existing.current_stock += weightIn;
          productMap.set(productId, existing);
        }
      });

      const mergedData = Array.from(productMap.values());

      for (const [productId, product] of productMap.entries()) {
        product.cost = product.prod_price * product.weightIn;

        productMap.set(productId, product);
      }

      setRaws(mergedData);
      setExistingRaw(mergedData);

      fetchProductionFinishProduct(mergedData);

      // setRaws(formattedData);
    } catch (error) {
      console.error("Error fetching raw materials:", error);
    }
  };

  const getRawMaterials = async (warehouseId, status) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/production/raw-materials/${id}`,
        {
          params: {
            warehouseId,
            status,
          },
        },
      );

      if (res.data.length > 0) {
        const rawMaterials = res.data.map((item) => ({
          stock_id: item.product_id,
          vendor_id: item.vendor_id,
          supplier_code: item.supplier_code || "Any",
          prod_id: item.product_id,
          prod_code: item.product_code,
          prod_name: item.product_name,
          prod_uom: item.uom,
          current_stock: item.current_stock,
          prod_price: item.unit_price,
          weightIn: item.quantity,
          cost: item.costing,
        }));

        setRaws(rawMaterials);
        setExistingRaw(rawMaterials);
      } else {
        setRaws([
          {
            stock_id: "",
            vendor_id: "Any",
            supplier_code: "Any",
            prod_id: "",
            prod_code: "",
            prod_name: "",
            prod_uom: "",
            current_stock: "",
            prod_price: "",
            weightIn: 0,
            cost: "",
          },
        ]);
        setExistingRaw([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchProductionFinishProduct = async (raws) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/production/getProductionFinishProductNew/${id}`,
      );

      if (response.data.length > 0) {
        const formattedProducts = response.data.map((item) => {
          return {
            prod_finish_raw_id: item["production_finish_products.id"],
            prod_id: item["production_finish_products.product_id"] || "",
            prod_code: item.product_code || "",
            product_name: item.product_name || "",
            prod_uom: item.unit_of_measure || "",
            produce: item["production_finish_products.produce"] || 0,
            current_stock: item.totalStock,
            unit_price: item["production_finish_products.unit_price"] || 0,
            costing: item["production_finish_products.costing"] || 0,
          };
        });

        setFinishedProductRows(formattedProducts);
      } else {
        setFinishedProductRows([
          {
            prod_id: "",
            prod_code: "",
            prod_name: "",
            prod_uom: "",
            produce: 0,
            current_stock: 0,
            costing: 0,
            unit_price: 0,
          },
        ]);
      }
    } catch (error) {
      console.error("Error production finish product:", error);
    }
  };

  const handleReject = async (event) => {
    event.preventDefault();
    if (submittingRef.current) return;
    try {
      swal({
        title: "Reject this production?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then(async (confirmed) => {
          if (confirmed) {
            if (!startSubmitting("reject")) return;

            const response = await axios.put(
              `${BASE_URL}/production/rejectProduction/${id}`,
              {
                raws,
                finishedProductRows,
                wareHouseID,
                transactionId: productionId,
                dateProduce,
                userLoggedID,
              },
            );

            if (response.status == 200) {
              swal({
                title: "Success",
                text: "Production rejected successfully",
                icon: "success",
                buttons: false,
                timer: 2000,
                dangerMode: true,
              }).then(() => {
                navigate("../inventory/productions");
              });
            } else {
              stopSubmitting();
            }
          } else {
            swal.close();
          }
        })
        .catch((error) => {
          stopSubmitting();
          console.log("test", error.response);
          if (error.response.status === 401) {
            swal({
              icon: "error",
              // title: "Please contact your support",
              title: error.response.data.title,
              text: error.response.data.message,
            }); // test 1
          } else {
            console.error(error);
          }
        });
    } catch (error) {
      console.log("test", error.response);
      if (error.response.status === 401) {
        swal({
          icon: "error",
          // title: "Please contact your support",
          title: error.response.data.title,
          text: error.response.data.message,
        }); // test 1
      } else {
        console.error(error);
      }
    }
  };

  const handleApprove = async (event) => {
    event.preventDefault();
    if (submittingRef.current) return;

    const validRaws = raws
      .filter((item) => item.prod_id && parseNumber(item.weightIn) > 0)
      .map((item) => ({ ...item, weightIn: parseNumber(item.weightIn) }));

    const validFinished = finishedProductRows
      .filter((item) => item.prod_id && parseNumber(item.produce) > 0)
      .map((item) => ({ ...item, produce: parseNumber(item.produce) }));

    const validConsumables = consumables
      .filter((item) => item.prod_id && parseNumber(item.weightIn) > 0)
      .map((item) => ({ ...item, weightIn: parseNumber(item.weightIn) }));

    const hasMaterials = validRaws.length > 0;
    const hasFinishedProducts = validFinished.length > 0;

    if (!hasMaterials && !hasFinishedProducts) {
      swal({
        icon: "error",
        title: "No Items Added",
        text: "Please add at least one Raw Material or Finished Product with either have more than 0 qty to approve this production.",
      });
      return;
    }

    let confirmTitle = "Approve this production?";
    let confirmText = "Please review the details before approving.";
    let isWarning = false;

    if (hasMaterials && !hasFinishedProducts) {
      confirmTitle = "No Finished Products Selected";
      confirmText =
        "You are approving a production with ONLY Raw Materials. Are you sure you want to proceed?";
      isWarning = true;
    } else if (!hasMaterials && hasFinishedProducts) {
      confirmTitle = "No Raw Materials Selected";
      confirmText =
        "You are approving a production with ONLY Finished Products. Are you sure you want to proceed?";
      isWarning = true;
    }

    try {
      swal({
        title: confirmTitle,
        text: confirmText,
        icon: "warning",
        buttons: {
          cancel: {
            text: "Cancel",
            value: null,
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Yes, Approve",
            value: true,
            visible: true,
            className: "btn-primary",
            closeModal: true,
          },
        },
        dangerMode: isWarning,
      })
        .then(async (confirmed) => {
          if (confirmed) {
            if (!startSubmitting("approve")) return;

            const response = await axios.put(
              `${BASE_URL}/production/approveProductionNew/${id}`,
              {
                raws: validRaws,
                finishedProductRows: validFinished,
                wareHouseID,
                selectedConsumable,
                quantity,
                dateProduce,
                productionCode: productionId,
                consumables: validConsumables,
                userLoggedID,
              },
            );

            if (response.status === 200) {
              swal({
                title: "Success",
                text: "Production Approved successfully",
                icon: "success",
                buttons: false,
                timer: 2000,
                dangerMode: true,
              }).then(() => {
                navigate("../inventory/productions");
              });
            } else {
              stopSubmitting();
            }
          } else {
            swal.close();
          }
        })
        .catch((error) => {
          stopSubmitting();
          if (error.response?.status === 401) {
            swal({
              icon: "error",
              // title: "Please contact your support",
              title: error.response.data.title,
              text: error.response.data.message,
            }); // test 1
          } else if (error.response) {
            if (
              error.response.status === 422 &&
              error.response.data.hasDeficit
            ) {
              const deficitItems = error.response.data.deficitItems || [];
              showDeficitAlert(deficitItems, "production");
            } else if (error.response.status === 400) {
              swal({
                icon: "warning",
                title: "Approval Failed",
                text: error.response.data.message,
              });
            } else {
              swal({
                icon: "error",
                title: "Something went wrong",
                text: "Please contact your support immediately.",
              });
            }
          }
        });
    } catch (error) {
      if (error.response.status === 401) {
        swal({
          icon: "error",
          // title: "Please contact your support",
          title: error.response.data.title,
          text: error.response.data.message,
        }); // test 1
      } else {
        console.error(error);
      }
    }
  };

  // Transition from Material Table to Finished Table
  const scrollToSide = (productCategory) => {
    const container = containerRef.current;
    if (!container) return;

    const itemWidth = containerRef.current.getBoundingClientRect().width; // Current Width of table container

    container.scrollTo({
      ...(productCategory === "finished"
        ? { left: itemWidth }
        : { left: -itemWidth }),
      behavior: "smooth",
    });
  };

  const calculateTotal = (arr, key) => {
    return arr.reduce((acc, value) => acc + parseNumber(value[key]), 0);
  };

  // Calculate Consumable Total Weight
  const calculateConsumableTotalWeight = () => {
    setConsumablesTotalWeight(calculateTotal(consumables, "weightIn"));
  };

  // Calculate Consumable Total Costing
  const calculateConsumableTotalCosting = () => {
    setConsumablesTotalCosting(calculateTotal(consumables, "cost"));
  };

  // Calculate Materials Total Weight
  const calculateMaterialTotalWeight = () => {
    setMaterialsTotalWeight(calculateTotal(raws, "weightIn"));
  };

  // Calculate Materials Total Costing
  const calculateMaterialTotalCosting = () => {
    setMaterialsTotalCosting(calculateTotal(raws, "cost"));
  };

  // Calculate Finished Product Total Produce/Weight
  const calculateFinishedProductTotalWeight = () => {
    setFinishedTotalWeight(calculateTotal(finishedProductRows, "produce"));
  };

  // Calculate Finished Product Total Costing
  const calculateFinishedProductTotalCosting = () => {
    setFinishedTotalCosting(calculateTotal(finishedProductRows, "costing"));
  };

  // Calculate Finished Product Costing when Produce field change
  const recalculateCostingOnProduceChange = () => {
    setFinishedProductRows((prev) => {
      let changed = false;

      // Newly updated finished product
      const updated = prev.map((item, index) => {
        // const produce = parseNumber(item.produce);

        // const ratio = finishedTotalWeight
        //   ? materialsTotalCosting / finishedTotalWeight
        //   : 0;

        // const newCosting = produce * ratio;

        // if (newCosting !== item.costing) {
        //   changed = true;
        // }
        const produce = parseNumber(item.produce);
        const unitPrice = parseNumber(item.unit_price);

        const newCosting = produce * unitPrice;
        return {
          ...item,
          // unit_price: !produce ? 0 : unitPrice,
          costing: newCosting,
        };
      });

      // Only Set finished product when something actually changed
      // To avoid infinite rerenders
      return changed ? updated : prev;
    });
  };

  // Calculate Finished Product Costing when Unit price field change
  const recalculateCostingOnUnitPriceChange = () => {
    setFinishedProductRows((prev) => {
      let changed = false;

      const otherRowIndexes =
        lastFocusedIndexUnitPrice !== null
          ? prev.map((_, i) => i).filter((i) => i != lastFocusedIndexUnitPrice)
          : null;

      const totalCosting = prev.reduce((acc, value) => acc + value.costing, 0);

      const remainingCost = materialsTotalCosting - totalCosting; // Get the difference between Materials and Finished Product total costing

      const avgDistributedCost =
        otherRowIndexes?.length > 0
          ? remainingCost / otherRowIndexes?.length
          : 0; // Distribute the remaining cost evenly across all items in otherRowIndexes.

      // Newly updated finished product
      const updated = prev.map((item, index) => {
        const produce = parseNumber(item.produce);

        const unitPrice = parseNumber(item.unit_price);

        const totalCostingPerUnit = item.costing + avgDistributedCost; // Add the evenly distributed remaining cost to the item's original costing.

        const newUnitPrice = produce > 0 ? totalCostingPerUnit / produce : 0; // Get the Final new unit price per produce

        const shouldApplyUnitPrice = otherRowIndexes?.includes(index);

        const finalUnitPrice = shouldApplyUnitPrice ? newUnitPrice : unitPrice;

        if (finalUnitPrice < 0) validateUnitPrice();

        const newCosting = produce * finalUnitPrice;

        if (newCosting !== item.costing) changed = true;

        return {
          ...item,
          unit_price: finalUnitPrice,
          costing: newCosting,
        };
      });

      // Only Set finished product when something actually changed
      // To avoid infinite rerenders
      return changed ? updated : prev;
    });
  };

  // Send warning to user if Total Produce exceeds the Total Weight In
  const validateTotalProduce = () => {
    if (
      finishedTotalWeight &&
      materialsTotalWeight &&
      finishedTotalWeight > materialsTotalWeight
    ) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("center-swal-text");
      wrapper.innerHTML = `The Total Produce cannot be greater than the total available weight <strong>(${materialsTotalWeight})</strong>, Please try again.`;
      swal({
        icon: "warning",
        title: "Weight Limit Exceeded",
        content: wrapper,
      }).then(() => {
        setLastFocusedIndex(null);
      });

      setFinishedProductRows((prev) =>
        prev.map((item, index) => {
          if (lastFocusedIndex == null) {
            return {
              ...item,
              unit_price: 0,
              produce: 0,
            };
          } else {
            return index === lastFocusedIndex
              ? {
                  ...item,
                  unit_price: 0,
                  produce: 0,
                }
              : item;
          }
        }),
      );
    }
  };

  // Send warning to user if unit price happens to be negative
  const validateUnitPrice = () => {
    swal({
      icon: "warning",
      title: "Invalid Unit Price",
      text: "The entered unit price adjustment caused one or more items to have a negative unit price. Please try again.",
    }).then(() => {
      setFinishedProductRows((prev) => {
        return prev.map((item, index) => {
          return index === lastFocusedIndexUnitPrice
            ? {
                ...item,
                unit_price: 0,
                produce: 0,
              }
            : item;
        });
      });

      setLastFocusedIndexUnitPrice(null);
    });
  };

  // Get only the produce values from finishedProductRows
  const produces = useMemo(
    () => finishedProductRows.map((item) => item.produce),
    [finishedProductRows.map((item) => item.produce).join(",")],
  );

  // Get only the unit_price values from finishedProductRows
  const unitPrices = useMemo(
    () => finishedProductRows.map((item) => item.unit_price),
    [finishedProductRows],
  );

  // useEffect(() => {
  //   fetchProductionFinishProduct();
  //   fetchWarehouse_function();
  //   fetchConsumableList();
  //   fetchVendor();
  //   fetchStockFinish();
  // }, []);

  // useEffect(() => {
  //   fetchInventoryCounting();
  // }, [id]);

  // useEffect(() => {
  //   calculateConsumableTotalWeight(); // Consumable Total Weight In
  //   calculateConsumableTotalCosting(); // Consumable Total Costing
  // }, [consumables]);

  // useEffect(() => {
  //   calculateMaterialTotalWeight(); // Material Total Weight In
  //   calculateMaterialTotalCosting(); // Material Total Costing
  // }, [raws]);

  // useEffect(() => {
  //   calculateFinishedProductTotalWeight(); // Finished Product Total Produce
  //   calculateFinishedProductTotalCosting(); // Finished Product Total Costing
  // }, [finishedProductRows]);

  const reloadData = async () => {
    await Promise.all([
      fetchProductionFinishProduct(),
      fetchWarehouse_function(),
      fetchConsumableList(),
      fetchVendor(),
      fetchStockFinish(),
      fetchInventoryCounting(),
    ]);
  };

  useEffect(() => {
    reloadData();
  }, [id]);

  useEffect(() => {
    calculateConsumableTotalWeight();
    calculateConsumableTotalCosting();
  }, [consumables]);

  useEffect(() => {
    calculateMaterialTotalWeight();
    calculateMaterialTotalCosting();
  }, [raws]);

  useEffect(() => {
    calculateFinishedProductTotalWeight();
    calculateFinishedProductTotalCosting();
  }, [finishedProductRows]);

  // Commented kasi sa Suntech is nangyayari na mas marami ang produce kesa sa materials
  // useEffect(() => {
  //   validateTotalProduce();
  // }, [finishedProductRows, unitPrice]);

  // commented kasi nag ka problema sa MJC nag rerecalculate ang unit price
  // hindi ko alam ano reason bat ako ang pa implement nito noon 9 months ago
  // as of June 16 2026

  // useEffect(() => {
  //   recalculateCostingOnProduceChange(); // Handle Costing Calculation as Produce field Change
  // }, [produces, unitPrice]);

  // useEffect(() => {
  //   recalculateCostingOnUnitPriceChange(); // Handle Costing Calculation as Unit Price field Change
  // }, [unitPrices]);

  // Custom input for DatePicker to strictly enforce MM/dd/yyyy hh:mm aa format
  const CustomInput = useMemo(() => {
    const Input = forwardRef(
      (
        {
          value,
          onClick,
          onChange,
          onBlur,
          onFocus,
          onKeyDown,
          disabled,
          required,
          className,
          placeholder,
          generateYears,
          ...rest
        },
        ref,
      ) => {
        const [localValue, setLocalValue] = useState(value || "");

        // Always mirror the picker's value (calendar picks keep the input focused,
        // so gating this on focus left the old date showing)
        useEffect(() => {
          setLocalValue(value || "");
        }, [value]);

        const handleChange = (e) => {
          let raw = e?.target?.value || "";
          const isDeleting = raw.length < localValue.length;
          let cursor = e.target.selectionStart;

          // Extract existing time from localValue to preserve it if user highlights all and erases the date
          const timeMatch = localValue.match(/\s?\d{1,2}:\d{2}\s?[aApP][mM]?/i);
          const preservedTime = timeMatch ? timeMatch[0].trim() : "";

          // If the user highlights everything and hits backspace OR replaces with a single digit, preserve the time
          if (raw === "" && preservedTime) {
            raw = " " + preservedTime;
          } else if (raw.length === 1 && /\d/.test(raw) && preservedTime) {
            raw = raw + " " + preservedTime;
          }

          let cleaned = raw.replace(/[^\d/ :aApPmM]/g, "");

          // Allow free 1-by-1 backspacing by bypassing the strict rebuild during deletion
          if (isDeleting) {
            setLocalValue(cleaned);
            e.target.value = cleaned;

            // PREVENT PREMATURE VALIDATION:
            // Only fire onChange during deletion if it's completely empty or hits a valid threshold length
            if (
              cleaned === "" ||
              cleaned.length === 10 ||
              cleaned.length >= 16
            ) {
              if (onChange) onChange(e);
            }

            setTimeout(() => {
              if (e.target) e.target.setSelectionRange(cursor, cursor);
            }, 0);
            return;
          }

          // Rescue react-datepicker's initial single-digit hour format so it pads to double-digit (hh)
          if (cleaned.includes(":")) {
            let parts = cleaned.split(":");
            let beforeColon = parts[0];
            let afterColon = parts.slice(1).join(":");

            let spaceParts = beforeColon.trim().split(" ");
            if (spaceParts.length === 2 && spaceParts[1].length === 1) {
              spaceParts[1] = "0" + spaceParts[1];
              beforeColon = spaceParts.join(" ");
              cleaned = beforeColon + ":" + afterColon;
            }
          }

          let datePart = "";
          let timePart = "";
          let letters = "";

          // Isolate date and time based on space separator to protect the time block
          const spaceIndex = cleaned.search(/\s\d/);

          if (spaceIndex !== -1) {
            datePart = cleaned.substring(0, spaceIndex).replace(/[^\d]/g, "");
            timePart = cleaned.substring(spaceIndex).replace(/[^\d]/g, "");
            letters = cleaned
              .substring(spaceIndex)
              .replace(/[^apmAPM]/g, "")
              .substring(0, 2)
              .toUpperCase();
          } else {
            let digits = cleaned.replace(/[^\d]/g, "");
            datePart = digits.substring(0, 8);
            timePart = digits.substring(8, 12);
            letters = cleaned
              .replace(/[^apmAPM]/g, "")
              .substring(0, 2)
              .toUpperCase();
          }

          let formatted = "";

          // Date Formatting: MM/dd/yyyy
          if (datePart.length > 0) formatted += datePart.substring(0, 2);
          if (datePart.length > 2) formatted += "/" + datePart.substring(2, 4);
          if (datePart.length > 4) formatted += "/" + datePart.substring(4, 8);

          // Time Formatting: hh:mm
          if (
            timePart.length > 0 ||
            (spaceIndex !== -1 && datePart.length > 0)
          ) {
            if (formatted.length > 0 && !formatted.endsWith(" "))
              formatted += " ";
            if (timePart.length > 0) formatted += timePart.substring(0, 2);
            if (timePart.length > 2)
              formatted += ":" + timePart.substring(2, 4);
          }

          // AM / PM Formatting: aa
          if (letters.length > 0) {
            if (formatted.length > 0 && !formatted.endsWith(" "))
              formatted += " ";
            formatted += letters.startsWith("A")
              ? "AM"
              : letters.startsWith("P")
                ? "PM"
                : letters;
          }

          if (cursor === raw.length) {
            cursor = formatted.length;
          }

          setLocalValue(formatted);
          e.target.value = formatted;

          // PREVENT PREMATURE VALIDATION:
          // Only trigger onChange when the string length denotes a fully typed date (10) or date+time (16+)
          if (
            formatted === "" ||
            formatted.length === 10 ||
            formatted.length >= 16
          ) {
            if (onChange) onChange(e);
          }

          setTimeout(() => {
            if (e.target) e.target.setSelectionRange(cursor, cursor);
          }, 0);
        };

        // Only push uncommitted (partially typed) text, otherwise a stale value
        // would overwrite a date just picked from the calendar
        const handleBlur = (e) => {
          if (localValue !== (value || "")) {
            e.target.value = localValue;
            if (onChange) onChange(e);
          }
          if (onBlur) onBlur(e);
        };

        const handleKeyDown = (e) => {
          if (e.key === "Enter" && localValue !== (value || "")) {
            e.target.value = localValue;
            if (onChange) onChange(e);
          }
          if (onKeyDown) onKeyDown(e);
        };

        const handleFocus = (e) => {
          if (onFocus) onFocus(e);
        };

        const inputClassName =
          `form-control p-2 w-100 ${className || ""}`.trim();

        return (
          <input
            {...rest}
            type="text"
            className={inputClassName}
            style={{ cursor: disabled ? "not-allowed" : "text" }}
            onClick={(e) => {
              if (disabled) return;
              if (onClick) onClick(e);

              let dateYear = new Date().getFullYear();
              if (value) {
                const parsed = new Date(value);
                if (!isNaN(parsed.getTime())) {
                  dateYear = parsed.getFullYear();
                }
              }

              if (generateYears && typeof generateYears === "function") {
                generateYears(dateYear);
              }
            }}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            onKeyDown={handleKeyDown}
            value={localValue}
            ref={ref}
            placeholder={placeholder || "MM/dd/yyyy hh:mm aa"}
            disabled={disabled}
            required={required !== undefined ? required : true}
          />
        );
      },
    );

    Input.displayName = "CustomInput";
    return Input;
  }, []);

  // Props for Consumable Table component
  const consumableTableProps = {
    id,
    consumables,
    filteredConsumableOptions,
    stockConsumableProducts,
    setConsumables,
    shift,
    selectedWarehouse: wareHouseID,
    shiftWarehouseRef,
    validated,
    onInputFloat,
    deleteItemConsumable,
    consumableToDelete,
    existingConsumables,
    addNewItemConsumable,
    edit,
  };

  // Props for Material Table component
  const materialsTableProps = {
    id,
    raws,
    vendor: {
      vendorOptions,
      handleSupplierCodeChange,
      fetchRawMaterialStock,
    },
    selectedWarehouse: wareHouseID,
    filteredRawProductOptions,
    stock_raw_products,
    setMaterialToDelete,
    materialToDelete,
    setRaws,
    validated,
    edit,
    onInputFloat,
    finishedProductRows,
    deleteItemRaw,
    addNewItemRaw,
  };

  // Props for Finished Product Table component
  const finishedTableProps = {
    finishedProductRows,
    filteredFinishedProductOptions,
    stock_finish_products,
    setFinishedProductRows,
    validated,
    // Finished Products are now fully editable during post-approval edit.
    // updateProductionNew handles full reconciliation when status is Approved:
    // reverses old StockManagement / Production_History /
    // Inventory_Journal "in" entries, blocks if stock was consumed in a
    // Sales Invoice or Stock Transfer, then recreates everything with
    // the new values.
    edit: edit,
    setLastFocusedIndex,
    lastFocusedIndexUnitPrice,
    setLastFocusedIndexUnitPrice,
    deleteFinishedProduct,
    addNewItemFinishProduct,
  };

  const handleDateRangeChange = async (selectedDate, type) => {
    if (!edit) return;

    const isStart = type === "start";

    if (
      !isStart &&
      startDate &&
      selectedDate &&
      selectedDate < new Date(startDate)
    ) {
      swal({
        icon: "error",
        title: "Invalid Date Range",
        text: "End date cannot be earlier than the start date.",
      });
      return;
    }

    const dateLabel = isStart ? "Production Start Date" : "Production End Date";

    const isPosted = await postedCutoffValidation(
      selectedDate,
      (val) => {
        if (isStart) {
          setStartDate(startDate);
        } else {
          setDateProduce(val);
        }
      },
      dateLabel,
    );

    if (isPosted) return;

    if (isStart) {
      setStartDate(selectedDate);

      if (selectedDate) {
        const reactiveEndDate = new Date(selectedDate);
        reactiveEndDate.setDate(reactiveEndDate.getDate() + 0);
        setDateProduce(reactiveEndDate);
      } else {
        setDateProduce(null);
      }
    } else {
      setDateProduce(selectedDate);
    }
  };

  return (
    <div className="h-100 w-100 bg-white custom-container">
      {authrztn.includes("Productions-View") ? (
        <>
          <div className="w-100 p-2 d-flex flex-row justify-content-between">
            <div className="d-flex flex-column title-custom">
              <span className="fs-3">
                <Link to="/inventory/productions" className="text-dark me-2">
                  <i class="fa-solid fa-arrow-left"></i>
                </Link>
                PRODUCTION DETAILS
              </span>
            </div>
          </div>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleUpdateProduction}
          >
            <div className="container-fluid mt-3">
              <div className="row">
                <div className="col-sm mb-2">
                  <span>Production ID</span>
                  <input
                    type="text"
                    name=""
                    value={productionId}
                    className="form-control"
                    readOnly
                  />
                </div>
                <div className="col-sm mb-2">
                  <span>Start Date</span>
                  <CustomDatePicker
                    label={"Production start date"}
                    selected={startDate ? new Date(startDate) : ""}
                    handleDateChange={(date) => {
                      handleDateRangeChange(date, "start");
                    }}
                    CustomInput={CustomInput}
                    isRequired={true}
                    validated={validated}
                    dateAndTime={true}
                    disabled={!edit}
                  />
                </div>
                <div className="col-sm mb-2">
                  <span>End Date</span>
                  <CustomDatePicker
                    label={"Production end date"}
                    selected={dateProduce ? new Date(dateProduce) : ""}
                    handleDateChange={(date) => {
                      handleDateRangeChange(date, "end");
                    }}
                    CustomInput={CustomInput}
                    isRequired={true}
                    validated={validated}
                    dateAndTime={true}
                    disabled={!edit}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm mb-2">
                  <span>Shift Schedule</span>
                  <Form.Select
                    required
                    value={shift}
                    onChange={(e) => setShift(e.target.value)}
                    disabled={!edit}
                  >
                    <option selected disabled value="">
                      Select Shift
                    </option>
                    <option value={"Day Shift"}>Day Shift</option>
                    <option value={"Night Shift"}>Night Shift</option>
                  </Form.Select>
                </div>
                <div className="col-sm mb-2">
                  <span>Machine</span>
                  <Form.Select
                    value={machine}
                    onChange={(e) => setMachine(e.target.value)}
                    disabled={!edit}
                  >
                    <option selected disabled value="">
                      Select Machine
                    </option>
                    <option value={"Machine 1"}>Machine 1</option>
                    <option value={"Machine 2"}>Machine 2</option>
                    <option value={"Machine 3"}>Machine 3</option>
                  </Form.Select>
                </div>
                <div className="col-sm">
                  <span>Warehouse</span>
                  <Form.Select
                    required
                    value={wareHouseID}
                    onChange={(e) => {
                      fetchStockConsumables(e.target.value);
                      fetchStockRaw(e.target.value);
                      fetchStockFinish(e.target.value);
                      setWareHouseID(e.target.value);
                    }}
                    disabled
                  >
                    <option disabled value="">
                      Select Warehouse
                    </option>
                    {fetchWarehouse.map((data) => (
                      <option id={data.warehouse_id} value={data.warehouse_id}>
                        {data.name}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </div>

              <div className="col-sm mb-2">
                <span>Product Description</span>
                <input
                  type="text"
                  name=""
                  value={description}
                  disabled={!edit}
                  onChange={(e) => setDescription(e.target.value)}
                  className="form-control"
                  placeholder="Enter Description"
                />
              </div>
            </div>

            {/* Controls */}
            {/* <div className="text-end">
              <span
                className="cursor-pointer fs-5 text-muted me-1"
                onClick={() => scrollToSide("materials")}
              >
                {visible[0] ? "●" : "○"}
              </span>
              <span
                className="cursor-pointer fs-5 text-muted"
                onClick={() => scrollToSide("finished")}
              >
                {visible[1] ? "●" : "○"}
              </span>
            </div> */}

            <div className="container-fluid">
              <div className="row gap-2 mb-4 mt-3">
                {/* For Consumables Totals */}
                <div className="col-sm">
                  <TotalCard
                    totalLabel={"Consumables Total"}
                    totalQuantity={consumablesTotalWeight}
                    totalCosting={consumablesTotalCosting}
                  />
                </div>

                {/* For Materials Totals */}
                <div className="col-sm">
                  <TotalCard
                    totalLabel={"Materials Total"}
                    totalQuantity={materialsTotalWeight}
                    totalCosting={materialsTotalCosting}
                  />
                </div>

                {/* For Finished Product Totals */}
                <div className="col-sm">
                  <TotalCard
                    totalLabel={"Finished Product Total"}
                    totalQuantity={finishedTotalWeight}
                    totalCosting={finishedTotalCosting}
                  />
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <div
                className="mt-1 production-form-container"
                ref={containerRef}
              >
                {/* For Consumables Table */}
                <ProductionConsumableCreateTable {...consumableTableProps} />

                {/* For Materials Table */}
                <ProductionMaterialsCreateTable {...materialsTableProps} />

                {/* For Finished Product Table */}
                <ProductionFinishedCreateTable {...finishedTableProps} />
              </div>
            </div>

            <div className="w-100 d-flex justify-content-end my-5 p-1">
              {status !== "Pending" ? null : (
                <>
                  {!edit ? (
                    <div className="d-flex justify-content-end gap-2">
                      {authrztn.includes("Productions-Edit") && (
                        <button
                          className="btn btn-primary px-4"
                          onClick={(e) => {
                            e.preventDefault();
                            setEdit(true);
                          }}
                        >
                          Edit
                        </button>
                      )}
                      <button
                        className="btn btn-danger px-4"
                        onClick={handleReject}
                        disabled={!!submittingAction}
                      >
                        {renderButtonLabel("reject", "Rejects", "Rejecting...")}
                      </button>
                      <button
                        className="btn btn-success px-4"
                        onClick={handleApprove}
                        disabled={!!submittingAction}
                      >
                        {renderButtonLabel(
                          "approve",
                          "Approve",
                          "Approving...",
                        )}
                      </button>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-end gap-2">
                      <button
                        className="btn btn-secondary px-4"
                        disabled={!!submittingAction}
                        onClick={(e) => {
                          e.preventDefault();
                          swal({
                            icon: "warning",
                            title: "Are you sure?",
                            text: "Your changes will not be saved",
                            dangerMode: true,
                            buttons: ["Cancel", "OK"],
                          }).then((confirmed) => {
                            if (confirmed) {
                              fetchInventoryCounting();
                              fetchProductionFinishProduct();
                              setEdit(false);
                              return;
                            }
                          });
                          return;
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary px-4"
                        type="submit"
                        disabled={!!submittingAction}
                      >
                        {renderButtonLabel("update", "Update", "Updating...")}
                      </button>
                    </div>
                  )}
                </>
              )}

              {status === "Approved" &&
                authrztn.includes("Productions-PostApprovalEdit") && (
                  <>
                    {!edit ? (
                      <div className="d-flex justify-content-end gap-2">
                        <button
                          className="btn btn-primary px-4"
                          onClick={(e) => {
                            e.preventDefault();
                            setEdit(true);
                          }}
                        >
                          Edit
                        </button>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-end gap-2">
                        <button
                          className="btn btn-secondary px-4"
                          disabled={!!submittingAction}
                          onClick={(e) => {
                            e.preventDefault();
                            swal({
                              icon: "warning",
                              title: "Are you sure?",
                              text: "Your changes will not be saved",
                              dangerMode: true,
                              buttons: ["Cancel", "OK"],
                            }).then((confirmed) => {
                              if (confirmed) {
                                fetchInventoryCounting();
                                fetchProductionFinishProduct();
                                setEdit(false);
                                return;
                              }
                            });
                            return;
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary px-4"
                          type="submit"
                          disabled={!!submittingAction}
                        >
                          {renderButtonLabel("update", "Update", "Updating...")}
                        </button>
                      </div>
                    )}
                  </>
                )}
            </div>
          </Form>

          {/* <div className="row mt-4">
            <div className="col-sm mb-2">
              <div className="table-responsive">
                <table className="w-100 custom-datatable">
                  <thead className="bg-light-custom thead-custom">
                    <tr>
                      <th className="p-2">Raw Materials</th>
                      <th className="p-2">UOM</th>
                      <th className="p-2">Current Stock</th>
                      <th className="p-2">Weight In</th>
                      <th className="p-2">Costing</th>
                      <th className=""></th>
                    </tr>
                  </thead>
                  <tbody>
                    {rawMaterials.length > 0 ? (
                      rawMaterials.map((item, index) => (
                        <tr key={index}>
                          <td className="p-2">
                            {item.stock_management.product_list.product_name}
                          </td>
                          <td className="p-2">
                            {item.stock_management.product_list.unit_of_measure}
                          </td>
                          <td className="p-2">
                            {item.stock_management.stock.toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                          <td className="p-2">
                            {item.weight_in.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                          <td className="p-2">{item.costing}</td>
                          <td className="p-2"></td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center p-2">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col-sm mb-2">
            <div className="table-responsive">
              <table className="w-100 custom-datatable2">
                <thead className="bg-light-custom thead-custom">
                  <tr className="custom-tr">
                    <th className="custom-th p-2">Finished Product</th>
                    <th className="custom-th p-2">Produce</th>
                    <th className="custom-th p-2">UOM</th>
                  </tr>
                </thead>
                <tbody className="custom-tbody">
                  {finishProducts.length > 0 ? (
                    finishProducts.map((item, index) => (
                      <tr key={index}>
                        <td className="p-2">
                          {item.product_list.product_name}
                        </td>
                        <td className="p-2">
                          {item.produce.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="p-2">
                          {item.product_list.unit_of_measure}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center p-2">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div> */}
        </>
      ) : (
        <div className="no-access">
          <img src={NoAccess} alt="NoAccess" className="no-access-img" />
          <h3>You don't have access to this function.</h3>
        </div>
      )}
    </div>
  );
}

export default NewProductionUpdate;
